<template>
  <nuxt-link
    :to="url"
    :class="{ selected: forceSelected }"
    @click.capture="handleClickButton"
  >
    <icon class="icon" :name="iconName" />
    <span class="label">
      {{ label }}
    </span>
  </nuxt-link>
</template>
<script setup lang="ts">
interface Props {
  label: string;
  url: string;
  iconName?: string;
  forceSelected?: boolean;
  isMainContent?: boolean;
}

const props = defineProps({
  label: null,
  url: null,
  iconName: { default: 'nomad:book' },
  forceSelected: { type: Boolean, default: false },
  isMainContent: { type: Boolean }
});

const profile = useProfileStore();

const handleClickButton = (e) => {
  if (props.isMainContent) {
    const url = profile.isParent
      ? `/${Sections.ParentForYou}`
      : `/${Sections.Revisions}`;
    navigateTo(url);
    e.preventDefault();
  }
};
</script>
<style lang="scss" scoped>
a {
  display: grid;
  position: relative;
  grid-template-columns: auto 1fr;
  align-items: center;
  width: 100%;
  padding: var(--gap_s);
  overflow: hidden;
  transition: border-color 150ms $ease-out-quad, color 300ms $ease-in-quad;
  border-width: var(--stroke_thickness_m);
  border-style: solid;
  border-radius: 2rem;
  border-color: var(--color_neutral_25);
  background-color: var(--color_neutral_25);
  color: var(--color_secondary_darker);
  gap: var(--gap_s);
  @include font('s', 500, 'secondary');
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    transform: translateX(100%) scaleX(0);
    border-radius: 1.6rem;
    opacity: 1;
    background-color: var(--color_secondary);
  }
  .label {
    color: var(--color_secondary_darker);
  }
  .icon {
    color: var(--color_secondary);
  }
  .label,
  .icon {
    position: relative;
    z-index: 1;
  }

  &:hover,
  &:focus,
  &.active,
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    @include pointer-desktop {
      .icon,
      .label {
        transition: color 300ms $ease-out-quad 100ms;
        color: var(--color_neutral_25);
      }

      border-color: var(--color_secondary);
      color: var(--color_neutral_25);

      &::before {
        transform: translateX(0%) scaleX(1);
        transition: transform 500ms $ease-out-quint, opacity 200ms $ease-in-quad,
          background-color 800ms $ease-out-quad;
        opacity: 1;
        background-color: var(--color_secondary);
      }
    }
  }
  &.selected,
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    .icon {
      color: var(--color_secondary);
    }
    .label {
      color: var(--color_secondary);
    }

    border-color: var(--color_secondary_light);
    background-color: var(--color_secondary_light);
    color: var(--color_secondary);
    &::before {
      background-color: var(--color_secondary_ligth);
    }
  }
}
</style>
